// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SessionsItemDetailsPopup__footer-f748ca {
  display: flex;
  margin: auto 16px 32px 16px;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
}

.SessionsItemDetailsPopup__shield-b7a06e {
  fill: var(--base-70);
  margin-inline-end: 4px;
}

.SessionsItemDetailsPopup__trusted-text-a4235f {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--base-70);
}

.SessionsItemDetailsPopup__pending-text-f901a5 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/Sessions/SessionsItemDetailsPopup/SessionsItemDetailsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,kBAAA;AACF","sourcesContent":[".footer {\n  display: flex;\n  margin: auto 16px 32px 16px;\n  justify-content: center;\n  align-items: center;\n  padding-top: 16px;\n}\n\n.shield {\n  fill: var(--base-70);\n  margin-inline-end: 4px;\n}\n\n.trusted-text {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--base-70);\n}\n\n.pending-text {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `SessionsItemDetailsPopup__footer-f748ca`,
	"shield": `SessionsItemDetailsPopup__shield-b7a06e`,
	"trusted-text": `SessionsItemDetailsPopup__trusted-text-a4235f`,
	"trustedText": `SessionsItemDetailsPopup__trusted-text-a4235f`,
	"pending-text": `SessionsItemDetailsPopup__pending-text-f901a5`,
	"pendingText": `SessionsItemDetailsPopup__pending-text-f901a5`
};
module.exports = ___CSS_LOADER_EXPORT___;
